import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import ModernAppBar from './ModernAppBar';
import MobileAppBar from './MobileAppBar';

const ResponsiveAppBar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile ? <MobileAppBar /> : <ModernAppBar />;
};

export default ResponsiveAppBar; 